import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { NewSmallGradientButton } from "./WalletDashboard";

interface ChipsConsolidateProps {
  selectedProfile: any;
  openConsolidateDialog: boolean;
  setOpenConsolidateDialog: (e: boolean) => void;
  handleConfirmConsolidate: any;
}

const ChipsConsolidate = (props: ChipsConsolidateProps) => {
  const {
    selectedProfile,
    openConsolidateDialog,
    setOpenConsolidateDialog,
    handleConfirmConsolidate,
  } = props;

  return (
    <Dialog
      open={openConsolidateDialog}
      onClose={() => setOpenConsolidateDialog(false)}
    >
      <DialogTitle>Confirm Consolidation</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to consolidate{" "}
          <strong>{selectedProfile?.balance}</strong> chips from{" "}
          <strong>{selectedProfile?.name}</strong> ({selectedProfile?.type})
          into your main account?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenConsolidateDialog(false)}>Cancel</Button>
        <NewSmallGradientButton onClick={handleConfirmConsolidate}>
          Confirm Consolidate
        </NewSmallGradientButton>
      </DialogActions>
    </Dialog>
  );
};

export default ChipsConsolidate;
